import Vue from 'vue';
import { Subscription } from '@/interfaces/notifications';
import { Commit } from 'vuex';

interface SubscriptionState {
	subscriptions: {
		[id: number]: Subscription;
	};
}

export default {
	namespaced: true,
	state: {
		subscriptions: {},
	} as SubscriptionState,
	getters: {
		getSubscriptions: (state: SubscriptionState): Subscription[] => {
			return Object.values(state.subscriptions);
		},

		getSubscription:
			(state: SubscriptionState) =>
			(id: number): Subscription | undefined => {
				return state.subscriptions[id];
			},
	},
	mutations: {
		SET_SUBSCRIPTIONS(state: SubscriptionState, subscriptions: Subscription[]): void {
			const ret: { [id: number]: Subscription } = {};
			state.subscriptions = subscriptions.reduce((obj, subscription) => {
				obj[subscription.id] = subscription;
				return obj;
			}, ret);
		},

		ADD_SUBSCRIPTION(state: SubscriptionState, subscription: Subscription): void {
			state.subscriptions = {
				...state.subscriptions,
				[subscription.id]: subscription,
			};
		},

		CHANGE_SUBSCRIPTION(state: SubscriptionState, subscription: Subscription): void {
			const oldClient = state.subscriptions[subscription.id] || {};
			state.subscriptions = {
				...state.subscriptions,
				[subscription.id]: { ...oldClient, ...subscription },
			};
		},

		CLEAN_SUBSCRIPTIONS(state: SubscriptionState): void {
			state.subscriptions = {};
		},
	},
	actions: {
		async fetchSubscriptions({ commit }: { commit: Commit }): Promise<void> {
			const response = await Vue.axios.get(
				`${process.env.VUE_APP_API_URL}/notifications/subscriptions`
			);
			if (response && response.status === 200) {
				commit('SET_SUBSCRIPTIONS', response.data.data);
			}
		},
		async addSubscription(
			{ commit }: { commit: Commit },
			{ subscription }: { subscription: Partial<Subscription> }
		): Promise<void> {
			const response = await Vue.axios.post(
				`${process.env.VUE_APP_API_URL}/notifications/subscriptions`,
				subscription
			);
			if (response && response.status === 201) {
				commit('ADD_SUBSCRIPTION', response.data.data);
			}
		},
		async modifySubscription(
			{ commit }: { commit: Commit },
			{ id, subscription }: { id: number; subscription: Partial<Subscription> }
		): Promise<void> {
			const response = await Vue.axios.put(
				`${process.env.VUE_APP_API_URL}/notifications/subscriptions/${id}`,
				subscription
			);
			if (response && response.status === 200) {
				commit('CHANGE_SUBSCRIPTION', response.data.data);
			}
		},
		clean({ commit }: { commit: Commit }): void {
			commit('CLEAN_SUBSCRIPTIONS');
		},
		cleanAll({ commit }: { commit: Commit }): void {
			commit('CLEAN_SUBSCRIPTIONS');
		},
	},
};
